import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Result } from 'app/models';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnChanges {

  @Input()
  result: Result | null;

  constructor(private translateService: TranslateService) {
    this.result = null;
  }

  ngOnChanges() {
    if (this.result != null && (this.result.success == true || this.result.success == false)) {
      if (this.result.success == true) {
        Swal.fire({
          icon: 'success',
          title: this.translateService.instant('Alert'),
          html: '<pre>' + this.translateService.instant(this.result.message) + '</pre>',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        });
      }
      else {
        let message = '';
        let customerEmployeeCodeError = '';
        if (this.result.message.includes('CustomerEmployeeWithCodeNotBeenFound') == true) {
          customerEmployeeCodeError = this.result.message.slice(28, this.result.message.length);
          this.result.message = this.result.message.slice(0, 28);
        }
        message = this.translateService.instant(this.result.message);
        if (this.result.message.includes('CustomerEmployeeWithCodeNotBeenFound') == true)
          message = message.replace('{{customerEmployeeCode}}', customerEmployeeCodeError);
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant('Alert'),
          html: '<pre>' + message + '</pre>',
          customClass: {
            confirmButton: 'btn btn-primary'
          }
        });
      }
    }
  }

  // public open(title: string, text: string, showCancelButton: boolean, success: boolean): void {
  //   if (showCancelButton == true) {
  //     Swal.fire({
  //       title: title,
  //       text: text,
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#7367F0',
  //       cancelButtonColor: '#E42728',
  //       confirmButtonText: 'Yes, delete it!',
  //       customClass: {
  //         confirmButton: 'btn btn-primary',
  //         cancelButton: 'btn btn-danger ml-1'
  //       }
  //     }).then(function (result) {
  //       if (result.value) {

  //       }
  //     });
  //   }
  //   else if (success == true) {
  //     Swal.fire({
  //       icon: 'success',
  //       title: title,
  //       text: text,
  //       customClass: {
  //         confirmButton: 'btn btn-success'
  //       }
  //     });
  //   }
  //   else {
  //     Swal.fire({
  //       icon: 'error',
  //       title: title,
  //       text: text,
  //       customClass: {
  //         confirmButton: 'btn btn-primary'
  //       }
  //     });
  //   }
  // }
}
